import RestService from '../../contracts/RestService';
import '../../utils/http-client';
export default class DraftService extends RestService {
    uri = 'drafts';
    getDraft = (id) => {
        return this.client.get(`${this.uri}/${id}`);
    };
    getRecentDrafts = async () => {
        const response = await this.client.get(`${this.uri}/recent`);
        return response.data;
    };
    getVideoDrafts = (id) => {
        return this.client.get(`${this.uri}/?videoid=${id}&isDrafts=true`);
    };
    requestedClips = (id) => {
        return this.client.get(`${this.uri}/?videoid=${id}`);
    };
    getUncompleted = () => {
        return this.client.get(`${this.uri}/uncompleted`);
    };
    markAllCompleted = () => {
        return this.client.post(`${this.uri}/completeall/`);
    };
    markCompleted = (id) => {
        return this.client.patch(`${this.uri}/completed/${id}`);
    };
    markIncomplete = (id) => {
        return this.client.patch(`${this.uri}/incomplete/${id}`);
    };
    makeProject = (id, projectName) => {
        return this.client.patch(`${this.uri}/makeproject/${id}`, { projectName });
    };
    renameProject = (id, projectName) => {
        return this.client.patch(`${this.uri}/rename/${id}`, { projectName });
    };
    getProjects = (videoId) => {
        return this.client.get(`${this.uri}/projects/${videoId}`);
    };
    generateSocialDescriptions = (id, regenerate) => {
        return this.client.get(`${this.uri}/descriptions/${id}?regenerate=${regenerate}`);
    };
}
